var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHrv = function SvgHrv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98.804A1 1 0 0 0 8.03.757L4.863 13.426l-.914-2.742A1 1 0 0 0 3 10H1a1 1 0 1 0 0 2h1.28l1.771 5.316a1 1 0 0 0 1.92-.073L8.89 5.557l3.128 15.64a1 1 0 0 0 1.962 0L15.82 12h2.35a3.001 3.001 0 1 0 0-2H15a1 1 0 0 0-.98.804L13 15.9z"
  })));
};
export default SvgHrv;